module.exports = __webpack_public_path__ + "static/media/conf-app5.b5b1fc1f.png";